/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice } from '@reduxjs/toolkit';
import { createSliceHook, ErrorAction } from '../helpers';
import {
  QCTaskCommentsState,
  QCTaskCommentsFetchAction,
  QCTaskCommentsFetchSuccessAction,
  AddCommentAction,
  AddCommentSuccessAction,
} from './QCTaskComments.types';

const initialState: QCTaskCommentsState = {
  loading: false,
  data: null,
};

export const QCTaskCommentsSlice = createSlice({
  name: 'QCTaskComments',
  initialState,
  reducers: {
    fetchQCTaskComments: (state, action: QCTaskCommentsFetchAction) => {
      state.loading = true;
    },
    fetchQCTaskCommentsSuccess: (
      state,
      action: QCTaskCommentsFetchSuccessAction
    ) => {
      state.loading = false;
      state.data = action.payload;
    },
    fetchQCTaskCommentsFailure: (state, action: ErrorAction) => {
      state.loading = false;
    },
    addComment: (state, action: AddCommentAction) => {
      state.loading = true;
    },
    addCommentSuccess: (state, action: AddCommentSuccessAction) => {
      state.loading = false;
      state.data = state.data
        ? [...state.data, action.payload]
        : [action.payload];
    },
    addCommentFailure: (state, action: ErrorAction) => {
      state.loading = false;
      state.error = action.payload;
    },
    QCTaskCommentsClear: state => {
      state.data = null;
    },
  },
});

export const {
  fetchQCTaskComments,
  fetchQCTaskCommentsSuccess,
  fetchQCTaskCommentsFailure,
  addComment,
  addCommentSuccess,
  addCommentFailure,
  QCTaskCommentsClear,
} = QCTaskCommentsSlice.actions;

export const actions = {
  ...QCTaskCommentsSlice.actions,
};

export const useQCTaskCommentsSlice = createSliceHook(
  QCTaskCommentsSlice.name,
  actions
);
